import { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';



const Iconify = forwardRef(({ icon, width = 20, sx, ...other }, ref) => (
    <Box
        ref={ref}
        component="span"
        sx={{ width, height: width, display: 'inline-block', ...sx }}
        {...other}
    >
        <Icon icon={icon} width={width} height={width} />
    </Box>
));

export { Iconify };
